module.exports = __webpack_public_path__ + "img/fm-f-Path 57 Copy@3x.0ef936ac.png";